module.exports = __webpack_public_path__ + "/bundle/asset/U1_04-5b963e885260c044680dee76d775f1b5.gif";